type Json = string | number | boolean | null | Json[] | { [key: string]: Json };

export type CacheInterface = {
  load: (key: string) => Json;
  save: (key: string, value: Json) => void;
  clear: (key: string) => void;
};

export const localStorageCache: CacheInterface = {
  load: (key: string) => {
    const data = localStorage.getItem(key);
    if (!data) {
      return undefined;
    }
    return JSON.parse(data);
  },
  save: (key: string, value: Json) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  clear: (key: string) => {
    localStorage.removeItem(key);
  },
};
